// extracted by mini-css-extract-plugin
module.exports = {"busc":"SearchBar_busc__2Nhc4"};